export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

export const REQUEST__STARTED = 'REQUEST__STARTED';
export const REQUEST__SUCCEEDED = 'REQUEST__SUCCEEDED';
export const REQUEST__FAILED = 'REQUEST__FAILED';
export const REQUEST__FINISHED = 'REQUEST__FINISHED';

export const OAUTH__LOGIN = 'oauth-login';
export const OAUTH__TOKEN__REFRESH__REQUESTED = 'OAUTH__TOKEN__REFRESH__REQUESTED';
export const OAUTH__TOKEN__REFRESH__SUCCEEDED = 'OAUTH__TOKEN__REFRESH__SUCCEEDED';
export const OAUTH__TOKEN__REFRESH__FAILED = 'OAUTH__TOKEN__REFRESH__FAILED';
export const OAUTH__TOKEN__EXPIRED = 'OAUTH__TOKEN__EXPIRED';

export const SEMESTERS__REQUESTED = 'SEMESTERS__REQUESTED';
export const SEMESTERS__REQUESTED__SUCCEEDED = 'SEMESTERS__REQUESTED__SUCCEEDED';
export const SEMESTERS__REQUESTED__FAILED = 'SEMESTERS__REQUESTED__FAILED';

export const DROPBOX__USERS__REQUESTED = 'DROPBOX__USERS__REQUESTED';
export const DROPBOX__USERS__REQUESTED__SUCCEEDED = 'DROPBOX__USERS__REQUESTED__SUCCEEDED';
export const DROPBOX__USERS__REQUESTED__FAILED = 'DROPBOX__USERS__REQUESTED__FAILED';

export const DROPBOX__USER__MEMBERSHIPS__REQUESTED = 'DROPBOX__USER__MEMBERSHIPS__REQUESTED';
export const DROPBOX__USER__MEMBERSHIPS__REQUESTED__SUCCEEDED = 'DROPBOX__USER__MEMBERSHIPS__REQUESTED__SUCCEEDED';
export const DROPBOX__USER__MEMBERSHIPS__REQUESTED__FAILED = 'DROPBOX__USER__MEMBERSHIPS__REQUESTED__FAILED';

export const DROPBOX__USER__SUBMISSIONS__REQUESTED = 'DROPBOX__USER__SUBMISSIONS__REQUESTED';
export const DROPBOX__USER__SUBMISSIONS__REQUESTED__SUCCEEDED = 'DROPBOX__USER__SUBMISSIONS__REQUESTED__SUCCEEDED';
export const DROPBOX__USER__SUBMISSIONS__REQUESTED__FAILED = 'DROPBOX__USER__SUBMISSIONS__REQUESTED__FAILED';

export const DROPBOX__ASSIGNMENT__REQUESTED = 'DROPBOX__ASSIGNMENT__REQUESTED';
export const DROPBOX__ASSIGNMENT__REQUESTED__SUCCEEDED = 'DROPBOX__ASSIGNMENT__REQUESTED__SUCCEEDED';
export const DROPBOX__ASSIGNMENT__REQUESTED__FAILED = 'DROPBOX__ASSIGNMENT__REQUESTED__FAILED';

export const DROPBOXES__REQUESTED = 'DROPBOXES__REQUESTED';
export const DROPBOXES__REQUESTED__SUCCEEDED = 'DROPBOXES__REQUESTED__SUCCEEDED';
export const DROPBOXES__REQUESTED__FAILED = 'DROPBOXES__REQUESTED__FAILED';

export const DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED = 'DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED';
export const DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__SUCCEEDED = 'DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__SUCCEEDED';
export const DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__FAILED = 'DROPBOXES__UPDATE__SHOW_INDEX__REQUESTED__FAILED';

export const ASSIGNMENT__CREATE__REQUESTED = 'ASSIGNMENT__CREATE__REQUESTED';
export const ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED = 'ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED';
export const ASSIGNMENT__CREATE__REQUESTED__FAILED = 'ASSIGNMENT__CREATE__REQUESTED__FAILED';

export const ASSIGNMENT__UPDATE__REQUESTED = 'ASSIGNMENT__UPDATE__REQUESTED';
export const ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED = 'ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED';
export const ASSIGNMENT__UPDATE__REQUESTED__FAILED = 'ASSIGNMENT__UPDATE__REQUESTED__FAILED';

export const ASSIGNMENT__DELETE__REQUESTED = 'ASSIGNMENT__DELETE__REQUESTED';
export const ASSIGNMENT__DELETE__REQUESTED__SUCCEEDED = 'ASSIGNMENT__DELETE__REQUESTED__SUCCEEDED';
export const ASSIGNMENT__DELETE__REQUESTED__FAILED = 'ASSIGNMENT__DELETE__REQUESTED__FAILED';

export const ASSIGNMENT__COPY__REQUESTED = 'ASSIGNMENT__COPY__REQUESTED';
export const ASSIGNMENT__COPY__REQUESTED__SUCCEEDED = 'ASSIGNMENT__COPY__REQUESTED__SUCCEEDED';
export const ASSIGNMENT__COPY__REQUESTED__FAILED = 'ASSIGNMENT__COPY__REQUESTED__FAILED';

export const ASSIGNMENTS__REQUESTED = 'ASSIGNMENTS__REQUESTED';
export const ASSIGNMENTS__REQUESTED__SUCCEEDED = 'ASSIGNMENTS__REQUESTED__SUCCEEDED';
export const ASSIGNMENTS__REQUESTED__FAILED = 'ASSIGNMENTS__REQUESTED__FAILED';

export const ASSIGNMENTS__COPY__REQUESTED = 'ASSIGNMENTS__COPY__REQUESTED';
export const ASSIGNMENTS__COPY__REQUESTED__SUCCEEDED = 'ASSIGNMENTS__COPY__REQUESTED__SUCCEEDED';
export const ASSIGNMENTS__COPY__REQUESTED__FAILED = 'ASSIGNMENTS__COPY__REQUESTED__FAILED';

export const SUBMISSION__CREATE__REQUESTED = 'SUBMISSION__CREATE__REQUESTED';
export const SUBMISSION__CREATE__REQUESTED__SUCCEEDED = 'SUBMISSION__CREATE__REQUESTED__SUCCEEDED';
export const SUBMISSION__CREATE__REQUESTED__FAILED = 'SUBMISSION__CREATE__REQUESTED__FAILED';

export const SUBMISSION__UPDATE__REQUESTED = 'SUBMISSION__UPDATE__REQUESTED';
export const SUBMISSION__UPDATE__REQUESTED__SUCCEEDED = 'SUBMISSION__UPDATE__REQUESTED__SUCCEEDED';
export const SUBMISSION__UPDATE__REQUESTED__FAILED = 'SUBMISSION__UPDATE__REQUESTED__FAILED';

export const SUBMISSION__UPDATE__NOTDONE__REQUESTED = 'SUBMISSION__UPDATE__NOTDONE__REQUESTED';
export const SUBMISSION__UPDATE__NOTDONE__REQUESTED__SUCCEEDED = 'SUBMISSION__UPDATE__NOTDONE__REQUESTED__SUCCEEDED';
export const SUBMISSION__UPDATE__NOTDONE__REQUESTED__FAILED = 'SUBMISSION__UPDATE__NOTDONE__REQUESTED__FAILED';

export const SUBMISSION__CONFIRMATION__REQUESTED = 'SUBMISSION__CONFIRMATION__REQUESTED';
export const SUBMISSION__CONFIRMATION__REQUESTED__SUCCEEDED = 'SUBMISSION__CONFIRMATION__REQUESTED__SUCCEEDED';
export const SUBMISSION__CONFIRMATION__REQUESTED__FAILED = 'SUBMISSION__CONFIRMATION__REQUESTED__FAILED';

export const SUBMISSION__MEMBERSHIPS__REQUESTED = 'SUBMISSION__MEMBERSHIPS__REQUESTED';
export const SUBMISSION__MEMBERSHIPS__REQUESTED__SUCCEEDED = 'SUBMISSION__MEMBERSHIPS__REQUESTED__SUCCEEDED';
export const SUBMISSION__MEMBERSHIPS__REQUESTED__FAILED = 'SUBMISSION__MEMBERSHIPS__REQUESTED__FAILED';

export const SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED = 'SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED';
export const SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED = 'SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED';
export const SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__FAILED = 'SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__FAILED';

export const SUBMISSION__MEMBERSHIP__DELETE__REQUESTED = 'SUBMISSION__MEMBERSHIP__DELETE__REQUESTED';
export const SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__SUCCEEDED = 'SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__SUCCEEDED';
export const SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__FAILED = 'SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__FAILED';

export const ASSIGNMENT__CLEAR__REQUESTED = 'ASSIGNMENT__CLEAR__REQUESTED';
export const LOGS__CLEAR__REQUESTED = 'LOGS__CLEAR__REQUESTED';
export const SUBMISSION__CLEAR__REQUESTED = 'SUBMISSION__CLEAR__REQUESTED';

export const SUBSCRIPTIONS__UPDATE__REQUESTED = 'SUBSCRIPTIONS__UPDATE__REQUESTED';
export const SUBSCRIPTIONS__UPDATE__REQUESTED__SUCCEEDED = 'SUBSCRIPTIONS__UPDATE__REQUESTED__SUCCEEDED';
export const SUBSCRIPTIONS__UPDATE__REQUESTED__FAILED = 'SUBSCRIPTIONS__UPDATE__REQUESTED__FAILED';

export const LOGOUT__REQUESTED = 'logout-requested';
export const LOGOUT__COMPLETED = 'logout-completed';

export const UNAUTHENTICATE = 'UNAUTHENTICATE';

export const FILE__UPLOAD__REQUESTED = 'FILE__UPLOAD__REQUESTED';
export const FILE__UPLOAD__REQUEST__SUCCEEDED = 'FILE__UPLOAD__REQUEST__SUCCEEDED';
export const FILE__UPLOAD__REQUEST__FAILED = 'FILE__UPLOAD__REQUEST__FAILED';
export const FILE__UPLOAD__BAD__REQUEST = 'FILE__UPLOAD__BAD__REQUEST';

export const FILE__DELETE__REQUESTED = 'FILE__DELETE__REQUESTED';
export const FILE__DELETE__REQUEST__SUCCEEDED = 'FILE__DELETE__REQUEST__SUCCEEDED';
export const FILE__DELETE__REQUEST__FAILED = 'FILE__DELETE__REQUEST__FAILED';

export const FILE__DOWNLOAD__REQUESTED = 'FILE__DOWNLOAD__REQUESTED';
export const FILE__DOWNLOAD__REQUEST__SUCCEEDED = 'FILE__DOWNLOAD__REQUEST__SUCCEEDED';
export const FILE__DOWNLOAD__REQUEST__FAILED = 'FILE__DOWNLOAD__REQUEST__FAILED';

export const ASSIGNMENT__FILE__UPLOAD__REQUESTED = 'ASSIGNMENT__FILE__UPLOAD__REQUESTED';
export const ASSIGNMENT__FILE__UPLOAD__REQUEST__SUCCEEDED = 'ASSIGNMENT__FILE__UPLOAD__REQUEST__SUCCEEDED';
export const ASSIGNMENT__FILE__UPLOAD__REQUEST__FAILED = 'ASSIGNMENT__FILE__UPLOAD__REQUEST__FAILED';
export const ASSIGNMENT__FILE__UPLOAD__BAD__REQUEST = 'ASSIGNMENT__FILE__UPLOAD__BAD__REQUEST';

export const ASSIGNMENT__FILE__DELETE__REQUESTED = 'ASSIGNMENT__FILE__DELETE__REQUESTED';
export const ASSIGNMENT__FILE__DELETE__REQUEST__SUCCEEDED = 'ASSIGNMENT__FILE__DELETE__REQUEST__SUCCEEDED';
export const ASSIGNMENT__FILE__DELETE__REQUEST__FAILED = 'ASSIGNMENT__FILE__DELETE__REQUEST__FAILED';

export const ASSIGNMENT__FILE__DOWNLOAD__REQUESTED = 'ASSIGNMENT__FILE__DOWNLOAD__REQUESTED';
export const ASSIGNMENT__FILE__DOWNLOAD__REQUEST__SUCCEEDED = 'ASSIGNMENT__FILE__DOWNLOAD__REQUEST__SUCCEEDED';
export const ASSIGNMENT__FILE__DOWNLOAD__REQUEST__FAILED = 'ASSIGNMENT__FILE__DOWNLOAD__REQUEST__FAILED';

export const LOGS__REQUESTED = 'LOGS__REQUESTED';
export const LOGS__REQUESTED__SUCCEEDED = 'LOGS__REQUESTED__SUCCEEDED';
export const LOGS__REQUESTED__FAILED = 'LOGS__REQUESTED__FAILED';

export const DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED = 'DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED';
export const DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__SUCCEEDED = 'DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__SUCCEEDED';
export const DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__FAILED = 'DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__FAILED';

export const ASSIGNMENT__SUBMISSIONS__REQUESTED = 'ASSIGNMENT__SUBMISSIONS__REQUESTED';
export const ASSIGNMENT__SUBMISSIONS__REQUESTED__SUCCEEDED = 'ASSIGNMENT__SUBMISSIONS__REQUESTED__SUCCEEDED';
export const ASSIGNMENT__SUBMISSIONS__REQUESTED__FAILED = 'ASSIGNMENT__SUBMISSIONS__REQUESTED__FAILED';

export const RUNSCRIPT__REQUESTED = 'RUNSCRIPT__REQUESTED';
export const RUNSCRIPT__REQUESTED__SUCCEEDED = 'RUNSCRIPT__REQUESTED__SUCCEEDED';
export const RUNSCRIPT__REQUESTED__FAILED = 'RUNSCRIPT__REQUESTED__FAILED';

export const RUNSCRIPT__OUTPUT__REQUESTED = 'RUNSCRIPT__OUTPUT__REQUESTED';
export const RUNSCRIPT__OUTPUT__REQUESTED__SUCCEEDED = 'RUNSCRIPT__OUTPUT__REQUESTED__SUCCEEDED';
export const RUNSCRIPT__OUTPUT__REQUESTED__FAILED = 'RUNSCRIPT__OUTPUT__REQUESTED__FAILED';

export const RUNSCRIPTS__LATEST__REQUESTED = 'RUNSCRIPTS__LATEST__REQUESTED';
export const RUNSCRIPTS__LATEST__REQUESTED__SUCCEEDED = 'RUNSCRIPTS__LATEST__REQUESTED__SUCCEEDED';
export const RUNSCRIPTS__LATEST__REQUESTED__FAILED = 'RUNSCRIPTS__LATEST__REQUESTED__FAILED';

export const DROPBOXES__ROLES__REQUESTED = 'DROPBOXES__ROLES__REQUESTED';
export const DROPBOXES__ROLES__REQUESTED__SUCCEEDED = 'DROPBOXES__ROLES__REQUESTED__SUCCEEDED';
export const DROPBOXES__ROLES__REQUESTED__FAILED = 'DROPBOXES__ROLES__REQUESTED__FAILED';

export const ROLES__SELF__REQUESTED = 'ROLES__SELF__REQUESTED';
export const ROLES__SELF__REQUESTED__SUCCEEDED = 'ROLES__SELF__REQUESTED__SUCCEEDED';
export const ROLES__SELF__REQUESTED__FAILED = 'ROLES__SELF__REQUESTED__FAILED';

export const ASSIGNMENT__MEMBERSHIPS__REQUESTED = 'ASSIGNMENT__MEMBERSHIPS__REQUESTED';
export const ASSIGNMENT__MEMBERSHIPS__REQUESTED__SUCCEEDED = 'ASSIGNMENT__MEMBERSHIPS__REQUESTED__SUCCEEDED';
export const ASSIGNMENT__MEMBERSHIPS__REQUESTED__FAILED = 'ASSIGNMENT__MEMBERSHIPS__REQUESTED__FAILED';

export const EXIT__OVERLAY__REQUESTED = 'EXIT__OVERLAY__REQUESTED';


/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/